import Container from './editable/Container.js';
import Input from './editable/Input.js';
import notification from 'notification-js';

export const mapping = ({data}) => {
  return {
    properties: data
  }
}

export const transform = ({modal, updateProperties}) => {
  return {
    properties: function(renderProperties) {
      let form = modal.el.getElementsByClassName('propertiesForm')[0];
      let container = form.getElementsByClassName('field-item-container')[0];

      if (container.childElementCount == 0) {
        for (var key in renderProperties) {
          let template = `
            <div class="property-fields property-fields-${key}">
              <label>${renderProperties[key].name}</label>
            </div>
          `;

          container.innerHTML += template;

          let propertyField = container.getElementsByClassName('property-fields-'+key)[0];

          if (renderProperties[key].type == "number") {
            let inputField = document.createElement('input');
            inputField.type = "number";
            inputField.dataset.key = key;
            inputField.value = renderProperties[key].value;

            propertyField.appendChild(inputField);

            inputField.onkeyup = function(event) {
              event.preventDefault();
              this.properties[event.target.dataset.key].value = event.target.value;
              updateProperties();
            }.bind(this)
          }

          if (renderProperties[key].type == "boolean") {
            let options = `
              <option value="true">True</option>
              <option value="false">False</option>
            `;

            let selectField = document.createElement('select');
            selectField.id = key;
            selectField.name = key;
            selectField.dataset.key = key;
            selectField.dataset.value = renderProperties[key].value;

            selectField.innerHTML = options;

            propertyField.appendChild(selectField);
          }
        }

        let selectFields = container.getElementsByTagName('select');

        for (var i =0; i<selectFields.length;i++) {
          selectFields[i].selectedIndex = (selectFields[i].dataset.value == "true") ? 0 : 1;

          selectFields[i].onchange = function(event) {
            event.preventDefault();
            this.properties[event.target.dataset.key].value = (event.target.value == "true") ? true : false;
            updateProperties();
          }.bind(this);
        }
      }
    }
  }
}

export const getData = (properties, propertiesEditor) => {
  let propertiesData = {};
  for (var key in properties) {
    propertiesData[key] = {};
    propertiesData[key].name = properties[key].name;
    propertiesData[key].type = properties[key].type;

    if (properties[key].type == "number") {
      propertiesData[key].value = parseInt(properties[key].value);
    }

    if (properties[key].type == "boolean") {
      propertiesData[key].value = properties[key].value;
    }

  }

  return propertiesData;
}

export default function() {

  let template = `
    <div class="propertiesForm">
      <div class="field-item-container">
      </div>
    </div>
  `

  return `<div>
    ${template}
  </div>`;
};



// WEBPACK FOOTER //
// ./src/editors/Properties.js